import { render, staticRenderFns } from "./BtDimsMetricsModel.vue?vue&type=template&id=74984776&scoped=true&"
import script from "./BtDimsMetricsModel.vue?vue&type=script&lang=js&"
export * from "./BtDimsMetricsModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74984776",
  null
  
)

export default component.exports